import { merchantApi } from "@api";
import { PATH_HOME, enumStatus } from "@configs";
import { selectAuth } from "@redux";
import UIStore from "@Rocket-Innovation/components/store/useUIStore";
import { formatMessage, newFormatMessage, useNotify } from "@utils";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";

export const PageGetPointFromQr = () => {
    const { auth, userInfo } = useSelector(selectAuth);
    const { success, warning, error } = useNotify();
    const history = useHistory();
    const { id } = useParams<{ id: string }>();

    const checkIsLogin = () => {
        if (!auth?.accessToken) {
            warning("Please sign in to continue");
            localStorage.setItem("QRCODE", id);
            history.push(PATH_HOME);
            return true;
        } else if (userInfo?.status === enumStatus.INACTIVE) {
            localStorage.setItem("QRCODE", id);
            history.push(PATH_HOME);
            return true;
        } else {
            return false;
        }
    };
    const claimPoint = () => {
        UIStore.setState({ isLoading: true });
        if (!checkIsLogin()) {
            merchantApi
                .qrClaimPoint({
                    // merchantId: userInfo?.merchantId || "",
                    // userId: userInfo?.contact?.userId || "",
                    productOrderId: id,
                })
                .then((res) => {
                    UIStore.setState({ isLoading: false });
                    success(newFormatMessage(res));
                    history.push(PATH_HOME);
                })
                .catch((err) => {
                    // error(err.message);
                    UIStore.setState({ isLoading: false });
                    err.response?.data?.msg
                        ? error(newFormatMessage(err.response))
                        : error(formatMessage(err.response));

                    console.log(err);
                    history.push(PATH_HOME);
                })
                .finally(() => {
                    UIStore.setState({ isLoading: false });
                    history.push(PATH_HOME);
                });
        } else {
            UIStore.setState({ isLoading: false });
            warning("Please sign in to continue");
            localStorage.setItem("QRCODE", id);
            history.push(PATH_HOME);
        }
    };
    useEffect(() => {
        claimPoint();
    }, []);

    return <> </>;
};
